import { NaeSSchemaMap } from "../config/NaeSSchema";

export const cacheData = (userState: any) => ([
        ]);